<template>
    <v-dialog :value="dialog" max-width="700px" persistent @keydown.esc="chiudiDialog()">
        <v-card>
            <v-card-title class="headline">
                Esporta dati EXCEL
                <v-spacer />
                <v-btn icon @click="chiudiDialog()">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>

                <v-select label="Anno" v-model="annoSel" :items="anni" hide-details />

                <v-radio-group v-model="tipoDati">
                    <v-radio label="Materie prime" :value="'materiale'" />
                    <v-radio label="Commesse" :value="'commesse'" />
                    <v-radio label="Sintesi annuale" :value="'sintesi'" />
                </v-radio-group>

            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn @click="chiudiDialog()">Chiudi</v-btn>
                <v-btn color="primary" @click="esportaDati()">Esporta</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
var XLSX = require("xlsx-js-style");

import { esporta_dati } from '@/api/api.registroSintesiPers.js'

export default {
    props: {
        dialog: { type: Boolean, default: false },
        compCode: { type: String, default: '' },
        // Non influenza l'esportazione: le colonne dipendono dalla variante e le decide il server
        variante: { type: String, default: '' },
    },

    data() {
        return {
            tipoDati: 'materiale',
            anni: [],
            annoSel: new Date().getFullYear(),
        }
    },

    methods: {
        chiudiDialog() {
            this.$emit("close");
        },

        async esportaDati() {
            let data = {
                CompanyCode: this.compCode,
                Tipo: this.tipoDati,
                Anno: this.annoSel,
            }

            try {
                let res = await esporta_dati(data);
                let sheetData = res.data;

                // Il server risponde null in caso di errore o se non ci sono dati; la prima riga è l'intestazione
                if (!Array.isArray(sheetData) || sheetData.length <= 1) {
                    this.$toast.alert("Nessun dato da esportare");
                    return;
                }

                let nomeTipo = this.tipoDati === "materiale" ? "MateriePrime" : (this.tipoDati === "commesse" ? "Commesse" : "Sintesi");
                let nomeFile = "ExportPers" + nomeTipo + "_" + this.annoSel + "_" + (this.$route.query.cliente || "");

                let workbook = XLSX.utils.book_new();
                let ws = XLSX.utils.aoa_to_sheet(sheetData);

                // Imposta larghezza colonne
                ws["!cols"] = this.getDimensioneColonne(sheetData);

                // Applica lo stile alla prima riga
                this.stileIntestazione(ws, sheetData);

                // Nella sintesi i titoli delle sezioni (ACQUISTI / PRODUZIONE) sono in grassetto
                if (this.tipoDati === "sintesi")
                    this.grassettoSezioni(ws, sheetData);

                XLSX.utils.book_append_sheet(workbook, ws, nomeTipo);
                XLSX.writeFile(workbook, nomeFile + ".xlsx", { bookType: "xlsx", bookSST: false, type: "array" });
            } catch (error) {
                console.error("Errore durante l'esportazione dei dati:", error);
                this.$toast.error("Errore durante l'esportazione dei dati");
            } finally {
                this.$wait.close();
            }
        },

        stileIntestazione(ws, sheetData) {
            for (let c = 0; c < sheetData[0].length; c++) {
                const cellAddress = XLSX.utils.encode_cell({ r: 0, c });
                const cell = ws[cellAddress];
                if (cell) {
                    cell.s = {
                        font: {
                            name: "Calibri",
                            sz: 13,
                            bold: true
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center"
                        },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } }
                        }
                    };
                }
            }
        },

        grassettoSezioni(ws, sheetData) {
            for (let r = 1; r < sheetData.length; r++) {
                if (sheetData[r][0] !== "ACQUISTI" && sheetData[r][0] !== "PRODUZIONE") continue;

                for (let c = 0; c < sheetData[r].length; c++) {
                    const cell = ws[XLSX.utils.encode_cell({ r, c })];
                    if (cell) {
                        cell.s = { font: { name: "Calibri", sz: 11, bold: true } };
                    }
                }
            }
        },

        // Larghezza di ogni colonna in base al testo più lungo (da 10 a 45 caratteri)
        getDimensioneColonne(sheetData) {
            const minimo = 10;
            const massimo = 45;
            const larghezze = [];

            sheetData.forEach((riga, indiceRiga) => {
                riga.forEach((valore, c) => {
                    const testo = (valore === null || valore === undefined) ? "" : String(valore);
                    // L'intestazione è in grassetto e più grande: serve un po' più di spazio
                    const lunghezza = indiceRiga === 0 ? Math.ceil(testo.length * 1.2) : testo.length;
                    larghezze[c] = Math.max(larghezze[c] || 0, lunghezza);
                });
            });

            return Array.from(larghezze, l => ({ wch: Math.min(massimo, Math.max(minimo, l || 0)) }));
        },

        init() {
            // Si riparte da un elenco vuoto: il watch scatta a ogni apertura del dialog
            let anni = [];
            let currentYear = new Date().getFullYear();
            for (let i = 2024; i <= currentYear; i++) {
                anni.push(i);
            }
            this.anni = anni;
        },
    },


    computed: {
        role() {
            return this.$store.getters['user/getRole'];
        }
    },

    watch: {
        dialog: {
            handler(newVal) {
                if (newVal) {
                    this.init();
                }
            },
            immediate: true
        }
    }
}
</script>
